<template>
  <div class="right">
    <div class="right_wrap" v-for="(item, index) in rightChart" :key="index">
      <div class="title_name">{{ item.title }}</div>
      <div
        v-if="item.chartId !== '6'"
        :id="'chart' + item.chartId"
        class="charts"
      />
      <chartstics v-else class="charts" :linedata="chardata"></chartstics>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import singleLine from "../../components/chart/single_line.vue";
import halfPie from "../../components/chart/half_circle.vue";
import columnarBar from "../../components/chart/columnar_bar.vue";
import dataUrl from "../../libs/js/interfaceAddress.js";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import chartstics from "../../components/chart/chart_statistics.vue";
import echarts from "echarts";
export default {
  name: "right",
  props: {
    rightChart: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      chardata: {}
    };
  },
  components: {
    singleLine,
    halfPie,
    columnarBar,
    chartstics
  },
  mounted() {
    this.$bus.$off("charts_right_es").$on("charts_right_es", this.chartinit);
  },
  computed: {
    ...mapState(["todayDev"])
  },
  watch: {
    rightChart: {
      handler: function(newVal) {
        if (newVal) {
          this.chartinit();
        }
      }
    }
  },
  beforeDestroy() {
    this.$bus.$off("charts_right_es", this.chartinit);
  },
  methods: {
    chartinit() {
      this.rightChart.filter((item, i) => {
        this.$http
          .get(dataUrl.interfaceAddress.chartOptions, {
            params: { id: item.chartId }
          })
          .then(res => {
            if (res.data.code === 0) {
              if (res.data.body.chartId !== "6") {
                var Id = res.data.body.chartId;
                var chartId = "chart" + Id;
                var chartjson = res.data.body.opetion;
                var chart_params_data = res.data.body.data;
                const keys = Object.keys(chart_params_data);
                var chart = echarts.init(document.getElementById(chartId));
                keys.filter((item, i) => {
                  var reg = new RegExp(item, "g");
                  const newMsg = chartjson.replace(
                    reg,
                    chart_params_data[item]
                  );
                  chartjson = newMsg;
                });
                var options = JSON.parse(chartjson);
                chart.setOption(options);
              } else {
                this.chardata = res.data.body;
              }
            } else {
            }
          })
          .catch(err => {
            console.log(err);
          });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.right {
  width: 100%;
  height: 100%;
  color: white;
  position: relative;
  font-size: 16px;
  backdrop-filter: blur(10px);

  .title_name {
    //    font-size: 18px;
    width: 50%;
    margin-left: 47%;
    font-size: 20px;
    line-height: 20px;
    color: #17c4e4;
    font-weight: bold;
    text-align: center;
    margin-right: 10px;
  }
  .right_wrap {
    // background: url(../../../static/img/right.png) no-repeat;
    margin-top: 4%;
    width: 100%;
    height: 31%;
    position: relative;
    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/right.png)
      no-repeat;
    background-size: 100% 100%;
    margin-right: 9px;
    // background-color: rgba(2, 2, 2, 0.2);
    border-radius: 22px;
    .charts {
      height: 90%;
      width: 100%;
      // background-color: goldenrod;
    }
  }
  .alarm {
    //   height: 300px;  //大
    // 小
    //   height:277px;
    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/right.png)
      no-repeat;
    background-size: 100% 100%;
    margin-right: 18px;
    //   margin-bottom:30px;
    .alarm_line {
      // margin-top: 20px;
    }
  }
  .device {
    //   height: 266px;
    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/right.png)
      no-repeat;
    background-size: 100% 100%;
    margin-right: 18px;
    //   margin-bottom:32px;
    .device_bar {
      // margin-top: 20px;
    }
  }
  .isLine {
    //   height: 300px; //大
    //  height:277px;
    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/right.png)
      no-repeat;
    background-size: 100% 100%;
    margin-right: 18px;
    //   margin-bottom:30px;
    .realTime_title {
      // padding: 40px 0px 0px 40px;
      // padding: 10px 0  0 20px;
      margin-left: 20px;
      font-size: 18px;
      font-weight: 400;
    }
    .realTime_statistics {
      display: flex;
      text-align: center;
      // padding-top: 30px;
      font-size: 16px;
      .realTime1 {
        flex: 1;
        color: #00e4ff;
      }
      .realTime2 {
        flex: 1;
        color: #009944;
      }
      .realTime3 {
        flex: 1;
        color: #f90002;
      }
    }
    .isLine_pie {
      // margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main_content/right_content.vue